import { UserProfile } from 'components/userProfile';

import { useConversationRow } from '../../../utils/useConversationRow';

import styles from './conversationsTableAssignedAgent.module.scss';

/** Represents the content of the assigned agent cell in the conversations table. */
export const ConversationsTableAssignedAgent = (): JSX.Element | null => {
  const {
    conversationAndRequester: { conversation },
  } = useConversationRow();

  // TODO: Implement unassigned agent presentation
  return (
    <UserProfile
      user={conversation.assignment?.agent ?? undefined}
      unknownLabel="Unassigned"
      nameClassName={
        conversation.assignment?.agent ? undefined : styles.unassigned
      }
      truncateName
    />
  );
};
